// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchResults_wrapper__rsmCN","loading":"SearchResults_loading__HNOOG"};